module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    staticClass: "noko-filter",
    attrs: {
      "grid": true,
      "no-margin": true
    }
  }, [_c('Select', {
    attrs: {
      "name": "competition_id",
      "label": "Конкурс",
      "placeholder": "Выберите конкурс",
      "options": _vm.competition,
      "clearable": true
    },
    model: {
      value: (_vm.competitionId),
      callback: function($$v) {
        _vm.competitionId = $$v
      },
      expression: "competitionId"
    }
  }), _c('Select', {
    attrs: {
      "name": "student_id",
      "label": "Участник",
      "placeholder": "Выберите участника",
      "options": _vm.students,
      "clearable": true
    },
    model: {
      value: (_vm.studentId),
      callback: function($$v) {
        _vm.studentId = $$v
      },
      expression: "studentId"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e4eb98","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/progress/components/filter/NokoFilter.vue
// module id = bf1df2bbcdcd86500fdb
// module chunks = 11